import React from "react";

import { HubTableTemplate } from "../../components";

import DisplayTableContainer from "./DisplayTableContainer";
import { condition } from "./helper";
import EmptyTable from "./EmptyTable";
import { DISPLAY_FIELDS } from "./displays";

export const StationDisplayTable = ({
  table = {},
  fields = [],
  setWorkOrder = () => {},
  setRouteId = () => {},
  DisplayProps = {},
  allowNav = false,
}) => {
  const onClick = ({ workOrder, rid }) => {
    setWorkOrder({ workOrder, rid });
  };

  const onPartClick = ({ rid }) => {
    setRouteId(rid);
  };

  const onRowClick = (e, item) => {
    e.preventDefault();
    e.stopPropagation();
    onClick(item);
  };

  const filtered = DISPLAY_FIELDS?.filter((f) => fields.includes(f.id));
  const keys = filtered?.map(
    ({ label, sortable, navigate, value, ...rest }) => {
      if (value === "workOrder")
        return { ...rest, navigate: allowNav, value, onClick };
      if (["partNumber", "partName"].includes(value))
        return { ...rest, value, navigate: allowNav, onClick: onPartClick };
      return { ...rest, value };
    }
  );

  const items = filtered?.map(({ id, label, sortable }) => ({
    id,
    label,
    sortable,
  }));

  const headerProps = { items, includeCheckbox: false, includeEnd: false };
  const bodyProps = { keys, condition, onRowClick };

  return (
    <DisplayTableContainer
      title={table.title}
      count={table.count}
      {...DisplayProps}
    >
      {table?.count > 0 ? (
        <HubTableTemplate
          id={`${table.title}DisplayTable`}
          headerProps={headerProps}
          bodyProps={{ ...bodyProps, items: table.rows }}
        />
      ) : (
        <EmptyTable title={table.title} />
      )}
    </DisplayTableContainer>
  );
};

export default StationDisplayTable;
